import { CampaignOutlined } from '@mui/icons-material';
import { Tooltip, useTheme } from '@mui/material';

interface MarketingConsentIndicatorProps {
  level: number | null | undefined;
}

const MarketingConsentIndicator: React.FC<MarketingConsentIndicatorProps> = ({ level }) => {
  const theme = useTheme();

  const config: Record<number, { color: string; tooltip: string }> = {
    0: {
      color: theme.palette.grey[500],
      tooltip: 'לא מקבל הודעות שיווקיות',
    },
    1: {
      color: theme.palette.warning.main,
      tooltip: 'מקבל הכל מלבד שיווק',
    },
    2: {
      color: theme.palette.success.main,
      tooltip: 'מקבל הכל כולל שיווק',
    },
  };

  // TODO: הסר ברירת מחדל זו כשהשדה יגיע מהשרת
  const effectiveLevel = level ?? 2; // ברירת מחדל לבדיקה
  const currentConfig = config[effectiveLevel];

  if (!currentConfig) return null;

  return (
    <Tooltip title={currentConfig.tooltip} arrow>
      <CampaignOutlined
        sx={{
          fontSize: 16,
          color: currentConfig.color,
          transition: 'color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      />
    </Tooltip>
  );
};

export default MarketingConsentIndicator;
